import dayjs from 'dayjs';

import type { Input as FilterInput, Filters } from './types';

const formatArrayValue = (value: unknown[]): string[] => {
  return value
    .map(v => (dayjs.isDayjs(v) ? v.format('YYYY-MM-DD') : String(v)))
    .filter(Boolean);
};

const formatSingleValue = (
  key: string,
  value: unknown,
  config: Record<string, FilterInput>
): string[] => {
  const filterConfig = config[key];
  if (filterConfig?.type === 'date' && dayjs.isDayjs(value)) {
    return [value.format('YYYY-MM-DD')];
  }

  return [String(value)];
};

export const buildFilterParams = (
  values: Record<string, unknown>,
  config: Record<string, FilterInput>
): Filters => {
  const params: Filters = {};

  Object.entries(values).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const formattedValue = formatArrayValue(value);
      if (formattedValue.length) {
        params[key] = formattedValue;
      }
      return;
    }

    if (!value) return;

    params[key] = formatSingleValue(key, value, config);
  });

  return params;
};
